import React from 'react';
import { CardBase, HTML } from '../../components';
import { block } from '../../utils';
import './NewsCard.css';
const b = block('news-card');
const NewsCard = (props) => {
    const { date, isoDate, title, border, url } = props;
    return (React.createElement(CardBase, { className: b(), url: url, border: border },
        React.createElement(CardBase.Content, null,
            isoDate ? (React.createElement("time", { className: b('date'), dateTime: isoDate }, date)) : (React.createElement("p", { className: b('date') }, date)),
            React.createElement("h4", { className: b('title') },
                React.createElement(HTML, null, title)))));
};
export default NewsCard;
